(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cats-cups-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.cats-cups-featured__image, .cats-cups-card__image';

    document.querySelectorAll('.cats-cups-showcase').forEach((showcase) => {
      if (showcase.dataset.imageViewerReady === 'true') return;
      showcase.dataset.imageViewerReady = 'true';
      showcase.querySelectorAll('.cats-cups-featured__image').forEach((container) => {
        const sparkles = document.createElement('span');
        sparkles.className = 'cats-cups-sparkles';
        sparkles.setAttribute('aria-hidden', 'true');
        sparkles.innerHTML = '<span>✦</span><span>✧</span><span>✦</span>';
        container.appendChild(sparkles);
      });

      const viewer = document.createElement('dialog');
      viewer.className = 'cats-cups-image-viewer';
      viewer.setAttribute('aria-label', 'Enlarged product image');
      viewer.innerHTML = '<button class="cats-cups-image-viewer__close" type="button" aria-label="Close enlarged image">&times;</button><img alt=""><div class="cc-viewer-controls" style="display:flex;justify-content:center;align-items:center;gap:20px;padding:12px;background:#fff6f1;color:#633947"><button type="button" aria-label="Previous product photo">Previous</button><span aria-live="polite"></span><button type="button" aria-label="Next product photo">Next</button></div>';
      showcase.appendChild(viewer);

      const enlargedImage = viewer.querySelector('img');
      const closeButton = viewer.querySelector('button');
      const controls = viewer.querySelector('.cc-viewer-controls');
      const galleryButtons = controls.querySelectorAll('button');
      let gallery = [], photoIndex = 0;
      const showPhoto = () => {
        enlargedImage.src = gallery[photoIndex].src;
        enlargedImage.alt = gallery[photoIndex].alt || '';
        controls.style.display = gallery.length > 1 ? 'flex' : 'none';
        controls.querySelector('span').textContent = `${photoIndex + 1} / ${gallery.length}`;
      };
      const stepPhoto = (delta) => { if(gallery.length) { photoIndex = (photoIndex + delta + gallery.length) % gallery.length; showPhoto(); } };
      galleryButtons[0].addEventListener('click', () => stepPhoto(-1));
      galleryButtons[1].addEventListener('click', () => stepPhoto(1));
      viewer.addEventListener('keydown', (event) => {
        if(event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); stepPhoto(event.key === 'ArrowLeft' ? -1 : 1); }
      });
      let touchStart = null;
      enlargedImage.addEventListener('touchstart', event => { touchStart = event.changedTouches[0].clientX; }, {passive:true});
      enlargedImage.addEventListener('touchend', event => {
        if(touchStart !== null) { const delta = event.changedTouches[0].clientX - touchStart; if(Math.abs(delta) > 50) stepPhoto(delta < 0 ? 1 : -1); touchStart = null; }
      }, {passive:true});

      const openViewer = (container) => {
        const sourceImage = container.querySelector('img');
        if (!sourceImage) return;
        const galleryData = container.querySelector('.cc-product-gallery');
        gallery = galleryData ? JSON.parse(galleryData.textContent) : [];
        if(!gallery.length) gallery = [{src:sourceImage.currentSrc || sourceImage.src,alt:sourceImage.alt}];
        photoIndex = 0;
        showPhoto();
        viewer.showModal();
      };

      showcase.querySelectorAll(selector).forEach((container) => {
        const sourceImage = container.querySelector('img');
        container.tabIndex = 0;
        container.setAttribute('role', 'button');
        container.setAttribute('aria-label', `Enlarge ${sourceImage?.alt || 'product image'}`);
        container.addEventListener('click', () => openViewer(container));
        container.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openViewer(container);
          }
        });
      });

      closeButton.addEventListener('click', () => viewer.close());
      viewer.addEventListener('click', (event) => {
        const bounds = viewer.getBoundingClientRect();
        const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
        if (outside) viewer.close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
